// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"813ed9967b92b026c154","293":"5324967bfe884d4cb92d","518":"55a04e7c63601c41032e","779":"25f2855c71d485849c88"}[chunkId] + ".js";
};